module.exports = __webpack_public_path__ + "img/arrow-down-orange.b0a5ae51.svg";